import Icon from '@ant-design/icons';
import { MouseEventHandler } from 'react';

interface IProps {
    className?: string;
    onClick?: MouseEventHandler<HTMLSpanElement>;
}

export const CameraSvg = ({ className }: IProps) => (
    <Icon
        className={className}
        component={() => (
            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill="#9655FF"
                    d="M2.90981 3.9552H4.82081C5.32955 3.29625 5.92064 2.53296 5.92889 2.53296H10.0968C10.1066 2.53296 10.704 3.29626 11.218 3.95518H14.8428C15.5398 3.95518 16.1046 4.52624 16.1046 5.23092V12.6695C16.1046 13.3742 15.5398 13.9452 14.8428 13.9452H2.90981C2.21279 13.9452 1.64794 13.3742 1.64794 12.6695V5.2309C1.64794 4.52623 2.21281 3.9552 2.90981 3.9552ZM12.9324 7.1859C13.3293 7.1859 13.6508 6.86089 13.6508 6.46001C13.6508 6.05876 13.3293 5.73373 12.9324 5.73373C12.5359 5.73373 12.2144 6.05876 12.2144 6.46001C12.2144 6.86087 12.5359 7.1859 12.9324 7.1859ZM7.62956 12.1535C9.37469 12.1535 10.8417 10.7142 10.8417 8.93906C10.8417 7.16365 9.37469 5.72469 7.62956 5.72469C5.88479 5.72469 4.48765 7.16364 4.48765 8.93906C4.48765 10.7141 5.88479 12.1535 7.62956 12.1535Z"
                />
            </svg>
        )}
    />
);

export const SubjectSearchSvg = ({ className }: IProps) => (
    <Icon
        className={className}
        component={() => (
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_50_3156)">
                    <rect x="2.39941" y="2.74292" width="10" height="13" rx="1.5" fill="#9655FF" />
                    <line x1="4.88541" y1="8.11435" x2="8.77112" y2="8.11435" stroke="white" strokeWidth="1.25714" strokeLinecap="round" />
                    <line x1="4.88541" y1="10.9715" x2="7.05684" y2="10.9715" stroke="white" strokeWidth="1.25714" strokeLinecap="round" />
                    <path
                        d="M12.1775 1.67438C11.9413 1.03612 11.0386 1.03613 10.8024 1.67438L10.2696 3.11432C10.2623 3.13387 10.2469 3.14928 10.2274 3.15652L8.78742 3.68934C8.14916 3.92552 8.14916 4.82826 8.78742 5.06444L10.2274 5.59727C10.2469 5.6045 10.2623 5.61992 10.2696 5.63947L10.8024 7.0794C11.0386 7.71767 11.9413 7.71766 12.1775 7.0794L12.7103 5.63947C12.7175 5.61992 12.733 5.6045 12.7525 5.59727L14.1924 5.06444C14.8307 4.82826 14.8307 3.92552 14.1924 3.68934L12.7525 3.15652C12.733 3.14928 12.7175 3.13387 12.7103 3.11432L12.1775 1.67438Z"
                        fill="#9655FF"
                        stroke="white"
                    />
                </g>
            </svg>
        )}
    />
);

export const SendSvg = ({ className, onClick }: IProps) => (
    <Icon
        className={className}
        onClick={onClick}
        component={() => (
            <svg width="44" height="28" viewBox="0 0 44 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="44" height="28" rx="14" fill="url(#paint0_linear_84_2668)" />
                <path
                    d="M29.85 8.72496L27.1167 19.6583C26.725 21.2166 25.3917 21.9166 24.225 21.9166H24.2083C23.0333 21.9083 21.6917 21.1916 21.325 19.6166L20.6083 16.575L25.0917 12.0916C25.4167 11.7666 25.4167 11.2333 25.0917 10.9083C24.7667 10.5833 24.2333 10.5833 23.9083 10.9083L19.425 15.3916L16.3833 14.675C14.8083 14.3083 14.0917 12.9666 14.0833 11.8C14.075 10.625 14.775 9.27496 16.3417 8.88329L27.275 6.14996C28 5.96663 28.7583 6.17496 29.2917 6.70829C29.825 7.24163 30.0333 7.99996 29.85 8.72496Z"
                    fill="#F5EFFF"
                    fillOpacity="0.5"
                />
                <path
                    d="M29.3066 6.72335L29.2925 6.70752C29.8258 7.24085 30.0341 7.99919 29.8508 8.72419L28.7341 13.1867L21.5866 20.3367C21.4705 20.108 21.3829 19.8659 21.3258 19.6159L20.6091 16.5742L25.0925 12.0909C25.4125 11.7709 25.4175 11.2492 25.1075 10.9234L29.3066 6.72335Z"
                    fill="#F5EFFF"
                    fillOpacity="0.55"
                />
                <path
                    d="M29.2916 6.70839L29.3066 6.72339L25.1066 10.9234C25.0296 10.8427 24.9373 10.7782 24.835 10.7336C24.7328 10.6891 24.6227 10.6654 24.5112 10.6639C24.3997 10.6624 24.289 10.6832 24.1856 10.725C24.0822 10.7669 23.9882 10.8289 23.9091 10.9076L19.4258 15.3909L16.3841 14.6742C16.149 14.6203 15.9208 14.5394 15.7041 14.4334L22.8924 7.24506L27.2758 6.14923C28.0008 5.96589 28.7591 6.17423 29.2924 6.70756L29.2916 6.70839Z"
                    fill="#F5EFFF"
                />
                <path
                    d="M22.8917 7.24585L15.7042 14.4333C14.6 13.89 14.0908 12.7833 14.0833 11.8C14.075 10.625 14.775 9.27502 16.3417 8.88335L22.8908 7.24585H22.8917Z"
                    fill="white"
                />
                <defs>
                    <linearGradient id="paint0_linear_84_2668" x1="44" y1="24" x2="7.12557" y2="-2.51103" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#9655FF" />
                        <stop offset="1" stopColor="#B38AFE" />
                    </linearGradient>
                </defs>
            </svg>
        )}
    />
);

export const SendDisabledSvg = ({ className }: IProps) => (
    <Icon
        className={className}
        component={() => (
            <svg width="44" height="28" viewBox="0 0 44 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="44" height="28" rx="14" fill="url(#paint0_linear_93_200)" />
                <path
                    d="M29.8502 8.72496L27.1169 19.6583C26.7252 21.2166 25.3919 21.9166 24.2252 21.9166H24.2086C23.0336 21.9083 21.6919 21.1916 21.3252 19.6166L20.6086 16.575L25.0919 12.0916C25.4169 11.7666 25.4169 11.2333 25.0919 10.9083C24.7669 10.5833 24.2336 10.5833 23.9086 10.9083L19.4252 15.3916L16.3836 14.675C14.8086 14.3083 14.0919 12.9666 14.0836 11.8C14.0752 10.625 14.7752 9.27496 16.3419 8.88329L27.2752 6.14996C28.0002 5.96663 28.7586 6.17496 29.2919 6.70829C29.8252 7.24163 30.0336 7.99996 29.8502 8.72496Z"
                    fill="#B2B2B2"
                />
                <path
                    d="M29.3069 6.72335L29.2927 6.70752C29.826 7.24085 30.0344 7.99919 29.851 8.72419L28.7344 13.1867L21.5869 20.3367C21.4708 20.108 21.3832 19.8659 21.326 19.6159L20.6094 16.5742L25.0927 12.0909C25.4127 11.7709 25.4177 11.2492 25.1077 10.9234L29.3069 6.72335Z"
                    fill="#C0C0C0"
                    fillOpacity="0.98"
                />
                <path
                    d="M29.2916 6.70839L29.3066 6.72339L25.1066 10.9234C25.0296 10.8427 24.9373 10.7782 24.835 10.7336C24.7328 10.6891 24.6227 10.6654 24.5112 10.6639C24.3997 10.6624 24.289 10.6832 24.1856 10.725C24.0822 10.7669 23.9882 10.8289 23.9091 10.9076L19.4258 15.3909L16.3841 14.6742C16.149 14.6203 15.9208 14.5394 15.7041 14.4334L22.8924 7.24506L27.2758 6.14923C28.0008 5.96589 28.7591 6.17423 29.2924 6.70756L29.2916 6.70839Z"
                    fill="#CDCDCD"
                />
                <path
                    d="M22.8919 7.24585L15.7044 14.4333C14.6002 13.89 14.0911 12.7833 14.0836 11.8C14.0752 10.625 14.7752 9.27502 16.3419 8.88335L22.8911 7.24585H22.8919Z"
                    fill="#DCDCDC"
                />
                <defs>
                    <linearGradient id="paint0_linear_93_200" x1="44" y1="24" x2="7.12557" y2="-2.51103" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#ECECEC" />
                        <stop offset="1" stopColor="#EFEFEF" />
                    </linearGradient>
                </defs>
            </svg>
        )}
    />
);

export const UploadPictureSvg = ({ className, onClick }: IProps) => (
    <Icon
        className={className}
        onClick={onClick}
        component={() => (
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4.30566" y="6.08337" width="16.0745" height="19.8333" rx="2.50926" stroke="#1B1B48" strokeWidth="1.5" />
                <path
                    d="M4.84033 23.9176L8.95528 19.3712C9.15775 19.1475 9.25898 19.0357 9.37999 18.9892C9.48645 18.9483 9.60307 18.942 9.71333 18.9711C9.83866 19.0042 9.95144 19.1044 10.177 19.3048L13.7717 22.499C13.9998 22.7017 14.1139 22.8031 14.2404 22.836C14.3517 22.8649 14.4693 22.8577 14.5763 22.8156C14.6979 22.7676 14.7989 22.6532 15.0008 22.4243L19.9565 16.8065"
                    stroke="#1B1B48"
                    strokeWidth="1.5"
                    strokeLinecap="square"
                />
                <circle cx="17.7922" cy="13.4093" r="0.75" fill="#1B1B48" stroke="#1B1B48" strokeWidth="0.890124" />
                <path d="M7.54053 12.2142H14.0612M10.8009 8.95496V15.4735" stroke="#1B1B48" strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M23.2695 8.88892L24.8378 9.19001L24.8745 9.19707C26.6023 9.52879 27.7548 11.1718 27.4785 12.9093L26.1153 21.4802C25.8492 23.1532 24.2587 24.2798 22.5921 23.9758V23.9758"
                    stroke="#1B1B48"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )}
    />
);
